import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { AMAZON_URL, PAPERBACK_URL } from "../site-data";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "The Book", href: "#book" },
  { label: "Stories", href: "#stories" },
  { label: "Free Story", href: "#free-story" },
  { label: "Works", href: "#works" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#f9f6f0]/85 border-b border-[#e5dcd0]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-logo"
          className="font-serif text-xl lg:text-2xl tracking-tight text-[#1c1a1a]"
        >
          Nitin&nbsp;Sawhney<span className="text-[#8b2e3e]">.</span>
        </a>

        <ul className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className="text-sm text-[#4a4646] hover:text-[#8b2e3e] link-underline transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href={AMAZON_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="navbar-buy-btn"
          className="hidden lg:inline-flex btn-rose items-center gap-2 bg-[#8b2e3e] hover:bg-[#6d2230] text-white px-5 py-2.5 text-sm tracking-wide transition-colors"
        >
          Buy on Amazon
        </a>

        <button
          aria-label="Toggle menu"
          data-testid="navbar-mobile-toggle"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden text-[#1c1a1a] p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div
          data-testid="navbar-mobile-panel"
          className="lg:hidden border-t border-[#e5dcd0] bg-[#f9f6f0]"
        >
          <ul className="flex flex-col py-4 px-6">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="block py-3 text-[#1c1a1a] font-serif text-xl"
                >
                  {l.label}
                </a>
              </li>
            ))}
            <li className="pt-3">
              <a
                href={AMAZON_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-[#8b2e3e] text-white px-5 py-2.5 text-sm tracking-wide"
              >
                Buy on Amazon
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}
